import { render, staticRenderFns } from "./LayoutButton.vue?vue&type=template&id=1e9b7f80&scoped=true&"
import script from "./LayoutButton.vue?vue&type=script&lang=js&"
export * from "./LayoutButton.vue?vue&type=script&lang=js&"
import style0 from "./LayoutButton.vue?vue&type=style&index=0&id=1e9b7f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9b7f80",
  null
  
)

export default component.exports